/** Shared placeholder tokens for project letter templates (Study Config + generate modals). */
export const LETTER_PLACEHOLDER_ITEMS = [
  { token: '{{Date}}', label: 'Date', description: 'Today (dd-MMM-yyyy)' },
  { token: '{{LetterDate}}', label: 'Letter Date', description: 'Same as Date' },
  { token: '{{PIName}}', label: 'PI Name', description: 'Principal Investigator' },
  { token: '{{SiteName}}', label: 'Site Name', description: 'Site description' },
  { token: '{{SiteCode}}', label: 'Site Code', description: 'Site code' },
  { token: '{{SiteAddress}}', label: 'Site Address', description: 'Investigator address lines' },
  { token: '{{ProtocolNo}}', label: 'Protocol No', description: 'Project code' },
  { token: '{{ProjectTitle}}', label: 'Project Title', description: 'Project description' },
  { token: '{{StudyReference}}', label: 'Study Reference', description: 'Project code' },
  { token: '{{VisitDate}}', label: 'Visit Date', description: 'Planned visit start date' },
  { token: '{{VisitType}}', label: 'Visit Type', description: 'SSV, SIV, etc.' },
  { token: '{{VisitTypeLabel}}', label: 'Visit Type Label', description: 'Full visit type name' },
  { token: '{{CRASignOff}}', label: 'CRA Sign-off', description: 'CRA name and profile' },
  { token: '{{CRAEmail}}', label: 'CRA Email', description: 'CRA email when available' },
];

export const LETTER_PLACEHOLDER_DRAG_TYPE = 'application/x-ctms-letter-placeholder';
